<template>
  <div>
    <el-row>
      <el-col>
        <el-button size="medium" type="primary" plain @click="exportList" style="margin-top: 20px">导出</el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-table :data="tableList" stripe border style="margin-top:20px">
          <el-table-column label="序号" type="index" width="50px"></el-table-column>
          <el-table-column label="编码" prop="PRODUCT_CODE"></el-table-column>
          <el-table-column label="名称" prop="SHORT_NAME" min-width="100"></el-table-column>
          <el-table-column label="品牌" prop="BRAND" min-width="100"></el-table-column>
          <el-table-column label="规格" prop="SPECIFICATION" min-width="100"></el-table-column>
          <el-table-column label="单位" prop="TYPE_UNIT"></el-table-column>
          <el-table-column label="价格" prop="REAL_PRICE"></el-table-column>
          <el-table-column label="订单数量" prop="REAL_GET_COUNT"></el-table-column>
          <el-table-column label="总金额" prop="TOTAL_FEE"></el-table-column>
        </el-table>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { exportGYSInvoiceFun, exportGYSInvoiceFunFun } from 'api/tcBanlance';

export default {
  data() {
    return {
      tableList: [],
    };
  },
  methods: {
    queryList() {
      const params = {
        GYS_ID: Number(sessionStorage.getItem('GYS_ID')),
        MONTH: sessionStorage.getItem('MONTH'),
        SUPPLIER_ID: sessionStorage.getItem('SUPPLIER_ID'),
      };
      exportGYSInvoiceFun(params).then((result) => {
        if (result.length !== 0) {
          this.tableList = result;
        } else {
          this.tableList = [];
          this.$message.show({ text: '暂无数据', type: 'success' });
        }
      }).catch((error) => {
        this.$message.show({ tetx: error, type: 'error' });
      });
    },
    exportList() {
      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            GYS_ID: Number(sessionStorage.getItem('GYS_ID')),
            MONTH: sessionStorage.getItem('MONTH'),
            SUPPLIER_ID: sessionStorage.getItem('SUPPLIER_ID'),
          };
          exportGYSInvoiceFunFun(params).then((result) => {
            if (result.length !== 0) {
              window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
              document.body.style.cursor = 'default';
            }
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally {}
      }
    },
  },
  created() {
    this.queryList();
  },
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/financeCenter/gysInvoiceDetail.vue